import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ps-0 mb-4 list-unstyled d-flex flex-wrap gap-2 gap-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: "/settings/account-settings",
        class: "btn btn-primary border border-primary bg-transparent text-primary py-2 px-3 fw-semibold"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Account Settings ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: "/settings/change-password",
        class: "btn btn-primary border border-primary bg-transparent text-primary py-2 px-3 fw-semibold"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Change Password ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: "/settings/connections",
        class: "btn btn-primary border border-primary bg-transparent text-primary py-2 px-3 fw-semibold"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Connections ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: "/settings/privacy-policy",
        class: "btn btn-primary border border-primary bg-transparent text-primary py-2 px-3 fw-semibold"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Privacy Policy ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_RouterLink, {
        to: "/settings/terms-conditions",
        class: "btn btn-primary border border-primary bg-transparent text-primary py-2 px-3 fw-semibold"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Terms & Conditions ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}